import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { StartUp } from '@app/StartUp'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StartUp />
  </StrictMode>
)
